<template>
	<div>
		<TilteParallax
			v-if="$vuetify.breakpoint.mdAndUp"
			image="https://apps.pinturasacuario.mx/assets/store/images/customer/article.jpg"
		>
			<template v-slot:title v-if="product">
				{{ `${product.category.name}` }}
			</template>

			<template v-slot:subtitle v-if="product">
				{{ product.name }}
			</template>
		</TilteParallax>

		<v-container fluid>
			<v-row justify="center">
				<v-col
					cols="12"
					md="10"
					lg="10"
					:class="[{ 'pa-0': $vuetify.breakpoint.smAndDown }]"
				>
					<v-card outlined :loading="ui.geting">
						<v-card-text
							:class="{ 'pa-0': $vuetify.breakpoint.smAndDown }"
						>
							<v-row justify="center">
								<v-col
									md="1"
									class="d-none d-md-flex flex-column mt-3 carousel-images-container"
								>
									<v-hover
										v-if="product"
										v-slot="{ hover }"
										v-for="(url, key) in productImages"
									>
										<v-card
											:elevation="hover ? 2 : 0"
											:class="[
												'mb-2',
												'pa-0',
												'carousel-image',
												{ 'on-hover': hover },
												{
													'slide-active':
														ui.slideActive === key,
												},
											]"
											color="#fff"
											outlined
											@click="setSlideActive(key)"
										>
											<v-card-text class="pa-0">
												<v-row>
													<v-col
														cols="12"
														class="d-flex justify-center align-center pa-1"
													>
														<img
															:src="url"
															alt=""
														/>
													</v-col>
												</v-row>
											</v-card-text>
										</v-card>
									</v-hover>
								</v-col>

								<v-col cols="12" md="7" class="pl-1 pr-1">
									<v-carousel
										cycle
										:height="
											$vuetify.breakpoint.smAndDown
												? '400px'
												: '80vh'
										"
										:show-arrows="
											productImages.length > 1
												? true
												: false
										"
										v-model="ui.slideActive"
									>
										<template v-if="productImages.length">
											<v-carousel-item
												v-for="(url,
												i) in productImages"
												:key="i"
											>
												<v-sheet
													color="#fff"
													height="100%"
												>
													<v-row
														class="fill-height"
														align="center"
														justify="center"
													>
														<img
															:src="url"
															alt=""
															height="90%"
														/>
													</v-row>
												</v-sheet>
											</v-carousel-item>
										</template>

										<template v-else>
											<v-carousel-item>
												<v-sheet
													color="#eee"
													height="100%"
												>
													<v-row
														class="fill-height"
														align="center"
														justify="center"
													>
														<v-col
															cols="12"
															class="d-flex justify-center text-center black--text"
														>
															Sin imagenes para
															mostrar.
														</v-col>
													</v-row>
												</v-sheet>
											</v-carousel-item>
										</template>
									</v-carousel>
								</v-col>

								<v-col
									cols="12"
									md="4"
									:class="[
										'pt-0',
										{
											'pa-5':
												$vuetify.breakpoint.smAndDown,
										},
									]"
								>
									<template v-if="product">
										<v-row>
											<v-col
												cols="12"
												class="pb-0 d-flex justify-end"
											>
												<h1 class="black--text">
													{{ product.name }}
												</h1>
											</v-col>

											<!-- PriceArticle Component -->
											<v-col
												cols="12 mt-2"
												v-if="article"
											>
												<Price
													:article="{
														...article,
														...layout,
													}"
												/>
											</v-col>
										</v-row>

										<!-- Selector Component -->
										<Selector
											class="mt-2"
											v-model="article"
											:articles="product.articles"
										></Selector>

										<v-row>
											<v-col
												cols="12 pt-0"
												v-if="BoxesMessage"
											>
												<v-alert
													border="left"
													class="ma-0"
													type="info"
												>
													{{ BoxesMessage }}
												</v-alert>
											</v-col>

											<v-col cols="12" v-if="article">
												<AmountIputGroup
													dense
													:label="
														BoxCapacity > 1
															? 'Caja'
															: 'Pieza'
													"
													v-model="layout.amount"
												/>
											</v-col>

											<v-col cols="12">
												<v-btn
													block
													large
													color="primary"
													:disabled="!article"
													@click="productCartAdd()"
												>
													agregar al carrito
													<v-icon class="ml-2">
														mdi-cart
													</v-icon>
												</v-btn>
											</v-col>
										</v-row>
									</template>

									<!-- Skeleton loader -->
									<template v-else>
										<v-row>
											<v-col cols="12">
												<v-skeleton-loader
													type="article, article, actions, article"
												></v-skeleton-loader>
											</v-col>
										</v-row>
									</template>
								</v-col>
							</v-row>

							<template v-if="product">
								<v-row>
									<v-col
										cols="12"
										class="d-flex justify-start"
									>
										<span class="category-title">
											{{
												`Detalles y caracteristicas de ${product.name}`
											}}
										</span>
									</v-col>

									<template v-if="article">
										<v-col
											cols="6"
											md="3"
											class="d-flex flex-column"
										>
											<h3>
												Contenido neto:
											</h3>
											{{ Weight }}
										</v-col>

										<v-col
											cols="6"
											md="3"
											class="d-flex flex-column"
										>
											<h3>
												Piezas por caja:
											</h3>

											<template
												v-if="article.box_capacity"
											>
												{{
													`${article.box_capacity} piezas`
												}}
											</template>
										</v-col>

										<v-col
											cols="6"
											md="3"
											class="d-flex flex-column"
										>
											<h3>
												Peso unitario:
											</h3>
											{{ NetContent }}
										</v-col>

										<v-col
											cols="6"
											md="3"
											class="d-flex flex-column"
										>
											<h3>
												Calidad:
											</h3>
											<Quality
												:quality="article.quality"
											></Quality>
										</v-col>

										<v-col
											cols="6"
											md="3"
											class="d-flex flex-column"
										>
											<h3>
												SKU:
											</h3>
											{{ article.code }}
										</v-col>

										<v-col
											cols="6"
											md="6"
											class="d-flex flex-column"
										>
											<h3>
												Descripción:
											</h3>
											{{ article.description }}
										</v-col>
									</template>
								</v-row>

								<v-row justify="center">
									<v-col cols="12" class="pt-0 pb-0">
										<v-row align="center">
											<v-col
												md="1"
												cols="12"
												:class="[
													'pa-0',
													'd-flex',
													'justify-center',
													'align-center',
													{
														'pt-3':
															$vuetify.breakpoint
																.smAndDown,
													},
												]"
											>
												<v-item-group
													v-model="ui.window"
													:class="[
														'd-flex',
														{
															'flex-column':
																$vuetify
																	.breakpoint
																	.mdAndUp,
														},
													]"
												>
													<v-item
														v-for="n in length"
														:key="n"
														v-slot="{
															active,
															toggle,
														}"
													>
														<v-btn
															icon
															:input-value="
																active
															"
															@click="toggle"
														>
															<v-icon
																>mdi-record</v-icon
															>
														</v-btn>
													</v-item>
												</v-item-group>
											</v-col>

											<v-col
												cols="12"
												md="11"
												:class="{
													'pt-0':
														$vuetify.breakpoint
															.smAndDown,
												}"
											>
												<v-window
													v-model="ui.window"
													:vertical="
														$vuetify.breakpoint
															.mdAndUp
													"
												>
													<v-window-item
														v-for="n in length"
														:key="n"
													>
														<v-card flat>
															<v-card-text>
																<v-row
																	align="center"
																>
																	<v-col
																		cols="12"
																		class="d-flex align-center"
																	>
																		<v-avatar
																			color="#EEE"
																		>
																			<v-icon
																				class="black--text"
																			>
																				mdi-format-paint
																			</v-icon>
																		</v-avatar>
																		<h3
																			class="ml-2"
																		>
																			Descripción:
																		</h3>
																	</v-col>
																</v-row>

																<v-row>
																	<v-col
																		cols="12"
																	>
																		<p>
																			Es
																			una
																			pinturaacrílica
																			modificada
																			de
																			última
																			generación,
																			creada
																			específicamente
																			para
																			realzar
																			la
																			belleza
																			de
																			cualquier
																			área
																			con
																			un
																			fino
																			acabado
																			mate.
																			Puede
																			ser
																			aplicada
																			en
																			superficies
																			de
																			cemento,
																			yeso,
																			ladrillo,
																			madera,
																			entre
																			otras;
																			contribuyendo
																			al
																			medio
																			ambiente
																			y
																			cuidando
																			tu
																			salud
																			debido
																			a su
																			formulación
																			libre
																			de
																			plomo.
																			Características:
																			Mayor
																			Lavabilidad
																			Ecológica
																			Duración
																			inigualable.
																		</p>
																	</v-col>

																	<v-col
																		cols="12"
																		class="d-flex justify-space-around flex-wrap"
																	>
																		<v-chip
																			v-for="characteristic in characteristics"
																			class="ma-1"
																			color="#eee"
																		>
																			{{
																				characteristic
																			}}
																			<v-icon
																				class="ml-1  green--text"
																			>
																				mdi-checkbox-marked-circle-outline
																			</v-icon>
																		</v-chip>
																	</v-col>
																</v-row>
															</v-card-text>
														</v-card>
													</v-window-item>
												</v-window>
											</v-col>
										</v-row>
									</v-col>
								</v-row>

								<v-row justify="center">
									<v-col cols="12">
										<v-row>
											<v-col
												cols="12"
												class="d-flex justify-start"
											>
												<span class="category-title">
													{{
														`Productos relacionados "${this.product.category.name}".`
													}}
												</span>
											</v-col>

											<v-col cols="12">
												<!-- Slide Group -->
												<SlideGroup
													:products="
														sliders.productsRelated
															.items
													"
													v-model="
														sliders.productsRelated
															.active
													"
												></SlideGroup>
											</v-col>
										</v-row>
									</v-col>

									<v-col cols="12">
										<v-row>
											<v-col
												cols="12"
												v-for="category in largeCategories"
											>
												<CategorySimpleLage
													:category="category"
												></CategorySimpleLage>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</template>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { EventBus } from "@/main";
import { mapGetters } from "vuex";
import Article from "@/clas/Article";
import Quality from "@/components/Article/Quality";
import Price from "@/components/Article/Show/Price";
import Selector from "@/components/Article/Show/Selector";
import TilteParallax from "@/components/TilteParallax";
import SlideGroup from "@/components/Carousel/SlideGroup";
import AmountIputGroup from "@/components/AmountIputGroup";
import CategorySimpleLage from "@/components/Category/LargeCard";

export default {
	components: {
		Price,
		Quality,
		Selector,
		SlideGroup,
		TilteParallax,
		AmountIputGroup,
		CategorySimpleLage,
	},

	data() {
		return {
			characteristics: [
				"Única con tecnología antihongos",
				"Excelente rendimiento",
				"Duración 5 Años",
				"Acabado mate",
				"Fácil integración, no produce grumos",
			],

			product: null,

			largeCategories: [
				{
					name: "Impermeabilizantes",
					description:
						"Acriterm el impermeabilizante elastomérico formulado a base de resinas estiren-acrílicas de la más alta calidad.",
					color: "orange",
				},
			],

			layout: {
				amount: 1,
			},

			article: null,

			length: 3,

			window: 0,

			sliders: {
				productsRelated: {
					items: [],
					active: 0,
				},
			},

			ui: {
				window: 0,
				valid: true,
				geting: true,
				slideActive: 0,
			},
		};
	},

	created() {
		this.get();

		let product = this.getProducts.find(
			(product) => product.id === this.$route.params.id
		);

		if (product) {
			this.product = product;
		}
	},

	methods: {
		async get() {
			try {
				this.ui.geting = true;

				let resp = await axios.get(
					`${process.env.VUE_APP_API_SERVER}/store/product/${this.$route.params.id}/article`,
					{
						headers: {
							Authorization: `Bearer ${this.account.token}`,
						},
					}
				);

				let product = resp.data.data;

				product.articles = product.articles.map((article) => {
					let complement = {
						price: article.base_price,
						discount: article.base_discount,
					};

					if (article.pivot) {
						complement = {
							preferential_price:
								article.pivot.preferential_price,
							preferential_discount:
								article.pivot.preferential_discount,

							price: article.pivot.preferential_price,
							discount: article.pivot.preferential_discount,
						};
					}

					return {
						...article,
						...complement,
					};
				});

				this.product = product;

				this.setProductsRelated();
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.geting = false;
			}
		},

		productCartAdd() {
			this.$store.dispatch("cart/productCartAdd", {
				...this.article,
				...this.layout,
				images: this.product.images,
				product_id: this.product.id,
			});

			// EventBus.$emit("Snackbar", {
			// 	text: "¡Producto agregado!",
			// 	type: "success",
			// });
		},

		setSlideActive(key) {
			this.ui.slideActive = key;
		},

		setProductsRelated() {
			this.sliders.productsRelated.items = this.getProductsWhereCategoryId(
				this.product.category_id
			);

			let product = this.sliders.productsRelated.items.find(
				(product) => product.id == this.$route.params.id
			);
			this.sliders.productsRelated.active = this.sliders.productsRelated.items.indexOf(
				product
			);
		},
	},

	computed: {
		...mapState({
			account: (state) => state.acount,
		}),

		...mapGetters([
			"getProducts",
			"getProductsWhereCategoryId",
			"getArticlesWhereCategoryId",
		]),

		NetContent() {
			const a = new Article(this.article);

			return a.netContent();
		},

		Weight() {
			let a = new Article(this.article);

			return a.weight();
		},

		BoxesMessage() {
			if (this.BoxCapacity > 1) {
				return `${this.layout.amount} caja(s) equivale a ${this.layout
					.amount * this.article.box_capacity} piezas.`;
			}

			return null;
		},

		BoxCapacity() {
			if (this.article) {
				if (this.article.box_capacity) {
					return this.article.box_capacity;
				}
			}

			return null;
		},
		productImages() {
			if (this.product) {
				if (this.product.images) {
					return this.product.images;
				}
			}

			return [];
		},
	},
};
</script>

<style lang="css" scoped>
.carousel-images-container {
	height: 80vh;
	overflow-y: scroll;
}

.carousel-images-container img {
	display: flex;
	max-width: 80% !important;
	max-height: 70px;
}

.carousel-image {
	border: 2px solid #ccc !important;
	transition: all 0.2s;
}

.carousel-image:hover {
	cursor: pointer;
	/*border-color: #0078d7 !important;*/
}

.slide-active {
	border-color: #005db9 !important;
}
</style>
